export default __webpack_public_path__ + "static/media/KristinGretaEric400.e18bcfc8.jpg";